<div class="container">
    <tam-upload [config]="uploadConfig"></tam-upload>
</div>